import type { JSX } from 'react';
import { Suspense } from 'react';
import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { AnimatedOutlet, AppHeader, AppNavbar, CenteredLoader, MiniPlayer } from './components';
import classes from './RootLayout.module.css';

function RootLayout(): JSX.Element {
  const [opened, { toggle, close }] = useDisclosure();

  return (
    <AppShell
      layout="alt"
      header={{ height: 60 }}
      navbar={{
        width: 240,
        breakpoint: 'sm',
        collapsed: { mobile: !opened, desktop: false },
      }}
      classNames={{
        navbar: classes.navbar,
      }}
    >
      <AppHeader opened={opened} toggle={toggle} />
      <AppNavbar onNavClick={close} />
      <AppShell.Main>
        {/* Suspense shows a loader while a lazily-imported route chunk loads. */}
        <Suspense fallback={<CenteredLoader />}>
          <AnimatedOutlet />
        </Suspense>
      </AppShell.Main>
      <MiniPlayer />
    </AppShell>
  );
}

export default RootLayout;
